/**
 * Identity model types for the canonical identity system.
 * Maps to the Prisma Identity model and IdentityType enum.
 */

import { BaseEntity } from '../common';

export enum IdentityType {
  PASSWORD = 'PASSWORD',
  MAGIC_LINK = 'MAGIC_LINK',
  OAUTH_GOOGLE = 'OAUTH_GOOGLE',
  OAUTH_APPLE = 'OAUTH_APPLE',
  OAUTH_GITHUB = 'OAUTH_GITHUB',
  OAUTH_FACEBOOK = 'OAUTH_FACEBOOK',
  PASSKEY = 'PASSKEY',
}

export interface Identity extends BaseEntity {
  userId: string;
  type: IdentityType;
  providerSubject: string | null;
  hashedCredential: string | null;
  emailVerified: boolean;
  metadata: Record<string, unknown> | null;
}
